module.exports = __webpack_public_path__ + "static/media/secondary-a-hero.25f31ff6.jpg";